export const localStock = {
    getItem (itemName) {
        return JSON.parse(localStorage.getItem(itemName) || null)
    },
    setItem (itemName, itemValue) {
        localStorage.setItem(itemName, JSON.stringify(itemValue))
    },
    removeItem (itemName) {
        localStorage.removeItem(itemName)
    }
}
